var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"blocker",style:({ zIndex: _vm.zIndex }),on:{"click":function($event){_vm.$emit('click');},"touchend":function($event){_vm.$emit('click');}}})])}
var staticRenderFns = []

export { render, staticRenderFns }